import React, { useContext, useEffect, useState, useRef } from "react";
import Modal from "react-modal";
import { Context } from "../contexts/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloudArrowDown,
  faXmark,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faPlay,
  faPause,
  faRotateRight,
  faExpand,
  faCamera,
  faHeart,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { getData, postData } from "../../lib/utils";



function PhotoThumbnail() {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  //const [favorites, setFavorites] = useState([]);
  const [showFavorites, setShowFavorites] = useState(false);
  const [modalOpen, setModalOpen] = useState(appState?.modalData || {});
  const [selectedIndex, setSelectedIndex] = useState(null);

  const [zoom, setZoom] = useState(1);
  const [isPlaying, setIsPlaying] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("All");

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);

  const [matchedPhotos, setMatchedPhotos] = useState([]);
  const [faceSearching, setFaceSearching] = useState(false);

  const dragStart = useRef({ x: 0, y: 0 });
  const intervalRef = useRef(null);
  const imageRef = useRef(null);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);



  const { galleryId } = useParams();
  const isGalleryId = (input) => /^[0-9a-fA-F]{24}$/.test(input);
  const { galleryId: identifier } = useParams();
 const navigate = useNavigate(); 
  console.log("PHOTOoooooooooooo Thumbnail..... ",appState)
   useEffect(() => {
      const handleMessage = (event) => {        
       console.log(event.data?.currentGalleryData?.setting,' ........message............... ',event.data );  
        if (typeof event.data === "object" && event.data !== null) {
            
           setAppState((prevState) => ({
             ...prevState,
             ...event.data,            
           }));
        }
      };
  
      window.addEventListener("message", handleMessage);
      return () => window.removeEventListener("message", handleMessage);
   }, [appState, setAppState]);
  
  useEffect(() => {
      
    const fetchData = async () => {
      try {
        let data;
        if (isGalleryId(identifier)) {
          data = await getData(`galleries/gallery/${identifier}`);
        } else {
          data = await getData(`galleries/gallery/customurl/${identifier}`);
        }
        

     
        if (data) {
          console.log("DDDDDDDDDDDDDDDDDDDD ",data)
          setAppState((prevState) => ({
            ...prevState,
            folder: data.folder,
            gallery: data.gallery,
            currentGalleryData: data.gallery,
            videos: data.videos,
            photos: data.photos,
            backgroundMedia: data?.gallery?.backgroundMedia,
            videoArr: data.videos || [],
            currentGalleryVideoTitle: data.gallery?.title || "",
            currentGalleryVideoSubTitle: data.gallery?.subtitle || "",

            currentTitleColor: data.gallery?.titleColor || "",
            currentSubTitleColor: data.gallery?.subTitleColor || "",
            currentFontFamilyVideoTitle: data.gallery?.fheading || "",
            currentFontFamilyVideoSubTitle: data.gallery?.fbody || "",
            currentTitleFontSize: data.gallery?.titleFontSize || "",
            currentSubTitleFontSize: data.gallery?.subTitleFontSize || "",
            currentFontLogo: data.gallery?.flogo || "",
            currentLogoColor: data.gallery?.logoColor || "",
            
          }));

          const response = await getData(
            `admin/admin-details-client/${data.folder.adminId}`
          );

          if (response) {
            if (window.injectBrandingAssets) {
              window.injectBrandingAssets(
                response?.admin?.id,
                data.gallery._id,
                process.env.REACT_APP_VIDEO_DEST_BASE_PATH,
                process.env.REACT_APP_API_PATH,
                response?.admin?.companyFaviconUrl,
                response?.admin?.companyLogoUrl,
                data?.gallery?.backgroundMedia?.imgUrl,
                data?.gallery?.title
              );
            }
            setAppState((prevState) => ({
              ...prevState,
              adminDetails: response.admin,
            }));
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [identifier, setAppState]);

  
  
  
  
  useEffect(() => {
  const handlePopState = () => {
    if (selectedIndex !== null) {
      setSelectedIndex(null);
      setIsPlaying(false);
    }
  };

  window.addEventListener(
    "popstate",
    handlePopState
  );

  return () => {
    window.removeEventListener(
      "popstate",
      handlePopState
    );
  };
  }, [selectedIndex]);

  
  useEffect(() => {
  const handlePopState = () => {

    if (selectedIndex !== null) {
      setSelectedIndex(null);
      setIsPlaying(false);
      return;
    }

    closeModal();
  };

  window.addEventListener(
    "popstate",
    handlePopState
  );

  return () => {
    window.removeEventListener(
      "popstate",
      handlePopState
    );
  };
}, [selectedIndex]);
  const closeFullscreen = () => {
  setSelectedIndex(null);
  setIsPlaying(false);

  if (window.history.state?.photoModal) {
    window.history.back();
  }
  };
  

 

  // ===============================
  // LOCK BODY SCROLL
  // ===============================
  useEffect(() => {
    if (selectedIndex !== null) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedIndex]);

  

 

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "100vw",
      height: "100vh",
      overflowY: "auto",
      backgroundColor: "#f3f4f6",
      padding: 0,
      border: "none",
    },
    overlay: {
      backgroundColor: "rgba(0,0,0,0.7)",
      zIndex: 9999,
    },
  };

const toggleFavorite = async (photo) => {
  try {
    const response = await postData(
      "photos/favoritePhoto",
      {
        photoId: photo._id,
      }
    );

    setAppState((prev) => ({
      ...prev,
      photos: prev.photos.map((p) =>
        p._id === photo._id
          ? {
              ...p,
              favorites: response.favorites,
            }
          : p
      ),
    }));

    // Face search result me bhi update
    setMatchedPhotos((prev) =>
      prev.map((p) =>
        p._id === photo._id
          ? {
              ...p,
              favorites: response.favorites,
            }
          : p
      )
    );
  } catch (error) {
    console.log(error);
    alert("Failed to update favorite");
  }
};
  // ===============================
  // CATEGORY FROM FILE NAME
  // ===============================
   // -----------------------------------
  // CATEGORY FROM FILE NAME
  // -----------------------------------
const getCategory = (fileName = "") => {
  const name = fileName.split("/").pop();

  const noExt = name.replace(/\.[^/.]+$/, "");
  const noNumber = noExt.replace(/[0-9]/g, "");
  const clean = noNumber.replace(/[_-]/g, "").trim();

  return clean.toLowerCase();
};
  // -----------------------------------
 
  
  // -----------------------------------
  // FILTER PHOTOS
  // -----------------------------------
// Face search result ho to wahi photos use karo
const sourcePhotos =
  matchedPhotos.length > 0
    ? matchedPhotos
    : (appState?.photos || []);

const filteredPhotos = sourcePhotos.filter((item) => {
  const category =
    item.folderName?.trim()
      ? item.folderName
      : getCategory(item.title);

  const matchesTab =
    activeTab === "All" ||
    category === activeTab;

  const matchesSearch =
    !searchTerm ||
    item.title
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase()) ||
    item.folderName
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase());

  return matchesTab && matchesSearch;
});
  // ===============================
  // DOWNLOAD
  // ===============================
const handleDownload = async (url, filename) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename || "image.jpg";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download failed:", error);
  }
};

  // ===============================
  // FULLSCREEN
  // ===============================
  const openFullscreen = () => {
    if (!imageRef.current) return;

    if (imageRef.current.requestFullscreen) {
      imageRef.current.requestFullscreen();
    } else if (imageRef.current.webkitRequestFullscreen) {
      imageRef.current.webkitRequestFullscreen();
    } else if (imageRef.current.msRequestFullscreen) {
      imageRef.current.msRequestFullscreen();
    }
  };

  // ===============================
  // CLOSE MODAL
  // ===============================
  const closeModal = () => {
     navigate(
        `/${galleryId}`
      );
  };

  // ===============================
  // RESET VIEW
  // ===============================
  const resetView = () => {
    setZoom(1);
    setPosition({ x: 0, y: 0 });
  };

  // ===============================
  // NEXT IMAGE
  // ===============================
  const nextImage = () => {
    setSelectedIndex((prev) =>
      prev === filteredPhotos.length - 1 ? 0 : prev + 1
    );

    resetView();
  };

  // ===============================
  // PREV IMAGE
  // ===============================
  const prevImage = () => {
    setSelectedIndex((prev) =>
      prev === 0 ? filteredPhotos.length - 1 : prev - 1
    );

    resetView();
  };

  // ===============================
  // KEYBOARD
  // ===============================
  useEffect(() => {
    const handleKey = (e) => {
      if (selectedIndex === null) return;

      if (e.key === "ArrowRight") nextImage();

      if (e.key === "ArrowLeft") prevImage();

      if (e.key === "Escape") {
        setSelectedIndex(null);
        setIsPlaying(false);
      }
    };

    window.addEventListener("keydown", handleKey);

    return () => window.removeEventListener("keydown", handleKey);
  }, [selectedIndex, filteredPhotos]);

  // ===============================
  // SLIDESHOW
  // ===============================
  useEffect(() => {
    if (isPlaying) {
      intervalRef.current = setInterval(nextImage, 3000);
    } else {
      clearInterval(intervalRef.current);
    }

    return () => clearInterval(intervalRef.current);
  }, [isPlaying, selectedIndex]);

  // ===============================
  // DRAG
  // ===============================
  const handleMouseDown = (e) => {
    if (zoom <= 1) return;

    setDragging(true);

    dragStart.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };
  };

  const handleMouseMove = (e) => {
    if (!dragging) return;

    setPosition({
      x: e.clientX - dragStart.current.x,
      y: e.clientY - dragStart.current.y,
    });
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  // ===============================
  // MOBILE SWIPE
  // ===============================
  const handleTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].screenX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].screenX;

    const diff = touchStartX.current - touchEndX.current;

    if (diff > 50) {
      nextImage();
    }

    if (diff < -50) {
      prevImage();
    }
  };

const prepareSelfieForSearch = (file) => {

  return new Promise((resolve) => {

    const img = new Image();

    const objectUrl =
      URL.createObjectURL(file);

    img.onload = () => {

      // =========================
      // MAX SIZE
      // =========================

      const MAX_WIDTH = 200;

      let width = img.width;
      let height = img.height;

      // resize
      if (width > MAX_WIDTH) {

        height =
          (height * MAX_WIDTH) / width;

        width = MAX_WIDTH;
      }

      // =========================
      // CANVAS
      // =========================

      const canvas =
        document.createElement("canvas");

      const ctx =
        canvas.getContext("2d");

      canvas.width = width;
      canvas.height = height;

      // white bg
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, width, height);

      ctx.drawImage(
        img,
        0,
        0,
        width,
        height
      );

      // =========================
      // EXPORT JPEG
      // =========================

      canvas.toBlob(

        (blob) => {

          URL.revokeObjectURL(objectUrl);

          const finalFile =
            new File(
              [blob],
              "selfie.jpg",
              {
                type: "image/jpeg",
              }
            );

          resolve(finalFile);
        },

        "image/jpeg",
        0.9
      );
    };

    img.src = objectUrl;
  });
  };
const favoritePhotos = sourcePhotos.filter(
  (p) => p.favorites
);
  const tabs = [
  "All",
  ...new Set(
    sourcePhotos
      .map((item) =>
        item.folderName?.trim()
          ? item.folderName
          : getCategory(item.title)
      )
      .filter(Boolean)
  ),
];
  // ===============================
  // SEARCH FACE
  // ===============================
const handleFaceSearch = async (e) => {

  let file = e.target.files[0];

  if (!file) return;

  try {
    file = await prepareSelfieForSearch(file);
 
    setFaceSearching(true);

    // =========================
    // UPLOAD FACE IMAGE
    // =========================

    const formData = new FormData();

    formData.append("photo", file);


    for (let pair of formData.entries()) {
  console.log('formmmmmmmmmm ',pair[0],'====' ,pair[1]);
}
  
    

    const uploadData = await postData(
      "photos/upload-face-search-photo",
      formData,
      true
    );
 
   
    // =========================
    // SEARCH FACE
    // =========================

    const searchData = await postData(
      "photos/search-face",
      {
        imageUrl: uploadData.url,
        galleryId,
      }
    );


    
    const matchedUrls =
      searchData?.matchedPhotos || [];

    const matched =
      appState?.photos?.filter((photo) =>
        matchedUrls.includes(photo.url)
      );

      console.log("Matched count:", matched.length);

   setMatchedPhotos(matched || []);
setActiveTab("All");
setSearchTerm("");
setSelectedIndex(null);

    if (!matched?.length) {

      alert("No matching photos found");

    } else {

      alert(
        `${matched.length} matching photos found`
      );
    }

  } catch (error) {

    console.log(error);

    alert("Face search failed");

  } finally {

    setFaceSearching(false);
  }
};
  return (
    <>
      {/* HEADER */}
      <div className="flex flex-col md:flex-row md:items-center justify-between px-4 mb-4 mt-8 gap-4">
        
        {/* LEFT */}
       <div>
  <h2 className="text-xl font-bold flex items-center gap-2">
    Photo Gallery

        <div
  className={`px-3 py-1 rounded-full text-sm cursor-pointer ${
    showFavorites
      ? "bg-red-500 text-white"
      : "bg-red-100 text-red-600"
  }`}
  onClick={() => {
    if (showFavorites) {
      // Normal photos
      setMatchedPhotos([]);
      setShowFavorites(false);
    } else {
      // Favourite photos
   const favs = sourcePhotos.filter(
  (p) => p.favorites
);

      setMatchedPhotos(favs);
      setShowFavorites(true);
    }
  }}
>
  Favorite Photos ❤️ {favoritePhotos.length}
</div>
            
  </h2>

  <p className="text-xs italic">
    Where Memories Live
  </p>
</div>

        {/* CENTER */}
        <div className="flex flex-col md:flex-row gap-3 flex-1 max-w-3xl w-full">
          
          {/* SEARCH */}
          <input
            type="text"
            placeholder="Search photos..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="flex-1 px-4 py-2 rounded-full border focus:outline-none focus:ring-2 focus:ring-yellow-500"
          />

          {/* SEARCH MY PHOTO */}
          <label className="bg-[#7a0a02] hover:bg-[#5f0802] text-white px-5 py-2 rounded-full cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 transition">
            
            <FontAwesomeIcon icon={faCamera} />

            {faceSearching ? "Searching..." : "Search My Photo"}

            <input
              type="file"
              accept="image/*"
              capture="user"
              hidden
              onChange={handleFaceSearch}
            />
          </label>

          {/* SHOW ALL */}
          {matchedPhotos.length > 0 && (
            <button
                onClick={() => {
    setMatchedPhotos([]);
    setActiveTab("All");
    setSearchTerm("");
  }}
              className="bg-gray-200 hover:bg-gray-300 px-5 py-2 rounded-full whitespace-nowrap transition"
            >
              Show All
            </button>
          )}
        </div>

        {/* CLOSE */}
        <FontAwesomeIcon
          icon={faXmark}
          className="text-3xl cursor-pointer"
          onClick={closeModal}
        />
      </div>

      {/* TABS */}
      <div className="flex overflow-x-auto mb-2">
        
        {tabs.map((tab, i) => (
          <button
            key={i}
            onClick={() => {
              setActiveTab(tab);
              setSelectedIndex(null);
            }}
            className={`relative px-2 md:px-4 py-2 text-sm uppercase whitespace-nowrap ${
              activeTab === tab
                ? "text-[#7a0a02] border-b-4 border-[#a52a1f]"
                : "text-[#7a0a02]"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* GRID */}
      <div className="columns-1 sm:columns-3 md:columns-4 md:gap-4 space-y-1 md:space-y-4 px-1 md:px-4 md:pb-6">
        {console.log("FILLLLLLLLLLL ",filteredPhotos)}
        {filteredPhotos?.map((item, index) => {
          return (
            <div
              key={item.url}
          onClick={() => {
  setSelectedIndex(index);

  window.history.pushState(
    { photoModal: true },
    ""
  );

  resetView();

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}}
              className="cursor-pointer break-inside-avoid rounded-xl overflow-hidden shadow-md bg-white relative group"
            >
              <img
               

                  src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item.url.replace(
    /\/([^/]+)$/,
    "/thumbs/$1"
                )}`}
                
                      src={
  appState?.currentGalleryData?.setting?.watermark
    ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item.url.replace(/\/([^/]+)$/, "/watermark/$1")}`
    : `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item.url}`
}
                alt={item?.title}
                className="w-full h-auto object-cover"
              />

              <div className="absolute bottom-0 left-0 right-0 bg-black/55 text-white text-xs px-3 py-2 truncate">
                {item?.title}
              </div>
 

   <div className="absolute bottom-1 right-2 gap-1 flex opacity-100 group-hover:opacity-100 transition">
  <button
    onClick={(e) => {
      e.stopPropagation();
      toggleFavorite(item);
    }}
    className="bg-white w-6 h-6 rounded-full flex items-center justify-center shadow-sm"
  >
    <FontAwesomeIcon
      icon={faHeart}
      className={item?.favorites ? "text-red-500 text-xs" : "text-gray-500 text-xs"}
    />
  </button>

{appState?.currentGalleryData?.setting?.download && (
  <button
    onClick={(e) => {
      e.stopPropagation();
      handleDownload(
        `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item?.url}`,
        item?.title
      );
    }}
    className="bg-gray-700 text-white w-6 h-6 rounded-full flex items-center justify-center"
  >
    <FontAwesomeIcon
      icon={faCloudArrowDown}
      className="text-xs"
    />
  </button>
)}
</div>
            </div>
          );
        })}
      </div>

      {/* FULLSCREEN VIEW */}
      {selectedIndex !== null && (
        <div
          className="fixed inset-0 bg-black flex items-center justify-center z-50 overflow-hidden touch-none"
          style={{
            touchAction: "none",
          }}
        >
          {/* TOP CONTROLS */}
          <div className="absolute top-4 right-4 flex gap-3 bg-black/50 p-3 rounded-full z-50">
            
            <div className="hidden md:flex items-center gap-5">
              
              <button onClick={resetView}>
                <FontAwesomeIcon
                  className="text-white"
                  icon={faRotateRight}
                />
              </button>



              <button
                onClick={() => setZoom((z) => Math.min(z + 0.2, 3))}
              >
                <FontAwesomeIcon
                  className="text-white"
                  icon={faMagnifyingGlassPlus}
                />
              </button>

              <button
                onClick={() => setZoom((z) => Math.max(z - 0.2, 1))}
              >
                <FontAwesomeIcon
                  className="text-white"
                  icon={faMagnifyingGlassMinus}
                />
              </button>

              <button onClick={() => setIsPlaying((p) => !p)}>
                <FontAwesomeIcon
                  className="text-white"
                  icon={isPlaying ? faPause : faPlay}
                />
              </button>

              <button onClick={openFullscreen}>
                <FontAwesomeIcon
                  className="text-white"
                  icon={faExpand}
                />
              </button>
            </div>

            <button
              onClick={() => {
                setSelectedIndex(null);
                setIsPlaying(false);
              }}
            >
              <FontAwesomeIcon
                className="text-white"
                icon={faXmark}
              />
            </button>
          </div>

          {/* IMAGE */}
          <div
            className="w-full h-full flex justify-center items-center overflow-hidden"
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <img
              ref={imageRef}
      src={
  appState?.gallery?.setting?.watermark
    ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${filteredPhotos[
        selectedIndex
      ]?.url.replace(/\/([^/]+)$/, "/watermark/$1")}`
    : `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${filteredPhotos[
        selectedIndex
      ]?.url}`
}
                   alt=""
              draggable={false}
              onMouseDown={handleMouseDown}
              style={{
                transform: `translate(${position.x}px, ${position.y}px) scale(${zoom})`,
                transition: dragging
                  ? "none"
                  : "transform 0.2s ease",
                cursor: zoom > 1 ? "grab" : "default",
              }}
              className="max-h-[80vh] max-w-[90vw] object-contain select-none touch-none"
            />
          </div>

          {/* DESKTOP NAV */}
          <div className="hidden md:block">
            
            <button
              onClick={prevImage}
              className="absolute left-4 text-white text-5xl z-50"
            >
              ‹
            </button>

            <button
              onClick={nextImage}
              className="absolute right-4 text-white text-5xl z-50"
            >
              ›
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default PhotoThumbnail;